// READ ME PLEASE:
//     THIS FILE IS A GENERATED. AND SHOULD BE GITIGNORED
//     YOU PROBABLY DO NOT WANT TO ALTER IT. IT'll WASTE YOUR TIME.
//     If it needs changes please set up a model that inherits and overrides
//     the behavior.

import {BaseModel} from '../Core/BaseModel';

import * as validators from '../Core/Validators';

import {
	PasswordsMatchValidator,
	RequiredValidator,
	PrimaryKeyRequiredValidator,
	PasswordRequiredValidator,
	MaxLengthValidator,
	NumericValidator,
	UnsignedNumberValidator,
} from '../Core/Validators';
import {UserContextNode} from './UserContextNode';
import {UserPermission} from './UserPermission';
import {UserAPIKey} from './UserAPIKey';
import {Organization} from './Organization';

const _associations = [
			{
				name: 'UserContextNodes',
				model: new UserContextNode(),
				type: 'ArrayOfChildren',
				using: 'userId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: 'update_user_context_nodes',
				group: 'Assignments',
				groupTitle: 'Assignments',
				displayOrder: 99,
				itemTitle: 'Assignment',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
			{
				name: 'UserPermissions',
				model: new UserPermission(),
				type: 'ArrayOfChildren',
				using: 'userId',
				isHidden: {
					requiresPermission: 'update_user_permissions'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: 'update_user_permissions',
				group: 'Permissions',
				groupTitle: 'Permissions',
				displayOrder: 7,
				itemTitle: 'Permissions',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: 'StreamBankUserPermissionList',
				customData: {
				}
			},
			{
				name: 'UserAPIKeys',
				model: new UserAPIKey(),
				type: 'ArrayOfChildren',
				using: 'userId',
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: false,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: false,
				isMutable: true,
				requiresPermission: 'can_generate_api_keys',
				group: 'API Keys',
				groupTitle: 'API Keys',
				displayOrder: 10,
				itemTitle: 'API Keys',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: 'UserAPIKeyMutableList',
				customData: {
					emptySuffix: ' issued',
				}
			},
			{
				name: 'Organization',
				model: new Organization(),
				type: 'ParentPointer',
				using: 'organizationId',
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				isOne: true,
				editor: 'ChildrenFieldEditor',
				viewer: 'ChildrenFieldViewer',
				isNullable: false,
				displayLabel: true,
				isMutable: true,
				requiresPermission: null,
				group: '',
				groupTitle: null,
				itemTitle: 'Organization',
				orderable: false,
				sortKey: null,
				nonMutable: false,
				listComponentOverride: false,
				customData: {
				}
			},
];

const _fieldDefs = [
			{
				title: 'userId',
				placeholder: null,
				key: 'userId',
				isPrimaryKey: true,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.userId,
				setter: (x, y) => x.userId = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new PrimaryKeyRequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Organization',
				placeholder: null,
				key: 'organizationId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'can_update_user_org',
				group: '',
				groupTitle: null,
				displayOrder: 3,
				getter: (x) => x.organizationId,
				setter: (x, y) => x.organizationId = y,
				defaultValue: null,
				editor: 'OrganizationFieldEditor',
				viewer: 'OrganizationFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Name',
				placeholder: null,
				key: 'name',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 1,
				getter: (x) => x.name,
				setter: (x, y) => x.name = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'UserNameFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Email Address',
				placeholder: null,
				key: 'email',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'can_update_user_email',
				group: '',
				groupTitle: null,
				displayOrder: 4,
				getter: (x) => x.email,
				setter: (x, y) => x.email = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
					new MaxLengthValidator(255),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'User Role',
				placeholder: null,
				key: 'userRoleId',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: 'can_update_user_role',
				group: '',
				groupTitle: null,
				displayOrder: 5,
				getter: (x) => x.userRoleId,
				setter: (x, y) => x.userRoleId = y,
				defaultValue: null,
				editor: 'UserRoleFieldEditor',
				viewer: 'UserRoleFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'Password',
				placeholder: null,
				key: 'password',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 6,
				getter: (x) => x.password,
				setter: (x, y) => x.password = y,
				defaultValue: null,
				editor: 'PasswordFieldEditor',
				viewer: 'PasswordFieldViewer',
				validators: [
					new MaxLengthValidator(255),
					new PasswordRequiredValidator(),
					new PasswordsMatchValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Mobile Number',
				placeholder: null,
				key: 'mobileNumber',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: {
					requiresPermission: 'can_update_user_mobile_number'
				},
				editorOnly: false,
				viewerOnly: false,
				helpText: 'Used for two factor authentication.',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 7,
				getter: (x) => x.mobileNumber,
				setter: (x, y) => x.mobileNumber = y,
				defaultValue: '',
				editor: 'PhoneFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(45),
				],
				formatter: {
				},
				customData: {
					hasExtension: false,
				}
			},
			{
				title: 'verified',
				placeholder: null,
				key: 'verified',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.verified,
				setter: (x, y) => x.verified = y,
				defaultValue: null,
				editor: 'NumberFieldEditor',
				viewer: 'NumberFieldViewer',
				validators: [
					new RequiredValidator(),
					new NumericValidator(),
				],
				formatter: {
					name: "NumberFormatter",
					params: [
					]
				},
				customData: {
				}
			},
			{
				title: 'rememberMeLookup',
				placeholder: null,
				key: 'rememberMeLookup',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.rememberMeLookup,
				setter: (x, y) => x.rememberMeLookup = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(12),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'rememberMeValidator',
				placeholder: null,
				key: 'rememberMeValidator',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.rememberMeValidator,
				setter: (x, y) => x.rememberMeValidator = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(64),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Profile Image',
				placeholder: null,
				key: 'image',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: true,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 2,
				getter: (x) => x.image,
				setter: (x, y) => x.image = y,
				defaultValue: null,
				editor: 'ImageUploadFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new MaxLengthValidator(-1),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'lastDailySummaryLog',
				placeholder: null,
				key: 'lastDailySummaryLog',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.lastDailySummaryLog,
				setter: (x, y) => x.lastDailySummaryLog = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'Terms Accepted On',
				placeholder: null,
				key: 'termsAccepted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: false,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				displayOrder: 8,
				getter: (x) => x.termsAccepted,
				setter: (x, y) => x.termsAccepted = y,
				defaultValue: null,
				editor: 'DateTimeFieldViewer',
				viewer: 'DateTimeFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
					format: 'MMMM d, yyyy',
					nullDisplayValue: 'Not Yet Accepted',
				}
			},
			{
				title: 'showSystemActivities',
				placeholder: null,
				key: 'showSystemActivities',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.showSystemActivities,
				setter: (x, y) => x.showSystemActivities = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'created',
				placeholder: null,
				key: 'created',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.created,
				setter: (x, y) => x.created = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'modified',
				placeholder: null,
				key: 'modified',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.modified,
				setter: (x, y) => x.modified = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'deleted',
				placeholder: null,
				key: 'deleted',
				isPrimaryKey: false,
				allowNull: true,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.deleted,
				setter: (x, y) => x.deleted = y,
				defaultValue: null,
				editor: 'DateFieldEditor',
				viewer: 'DateFieldViewer',
				validators: [
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'orgImage',
				placeholder: null,
				key: 'orgImage',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.orgImage,
				setter: (x, y) => x.orgImage = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
			{
				title: 'maskedNumber',
				placeholder: null,
				key: 'maskedNumber',
				isPrimaryKey: false,
				allowNull: false,
				displayLabel: true,
				isHidden: true,
				editorOnly: false,
				viewerOnly: false,
				helpText: '',
				requiresPermission: null,
				group: '',
				groupTitle: null,
				getter: (x) => x.maskedNumber,
				setter: (x, y) => x.maskedNumber = y,
				defaultValue: null,
				editor: 'TextFieldEditor',
				viewer: 'TextFieldViewer',
				validators: [
					new RequiredValidator(),
				],
				formatter: {
				},
				customData: {
				}
			},
];

export class User extends BaseModel {
	constructor() {
		super();
	}

	get groupRenderers() {
		return {
		};
	}

	get recordValidators() {
		return this._recordValidators ?? ( this._recordValidators = [		]);
	}

	get associations() {
		return _associations;
	}
	get fieldDefs() {
		return _fieldDefs;
	}

}
